import { useEffect, useState } from 'react';
import { useSettingsContext } from 'src/components/settings';
import PageHeader from 'src/components/page-header/page-header';
import ThemeBackgroundHeader from 'src/components/custom-theme/theme-background-header';
import { useAppliedTheme, HEADER_LAYOUT } from 'src/api/app-config';

const GREETING_KEY = 'overview:greetingDismissed';

export default function OverviewHeader() {
  const settings = useSettingsContext();
  const isHorizontal = settings.themeLayout === 'horizontal';
  const { theme, headerFit, headerLayout } = useAppliedTheme();
  const headerImage = theme?.headerImage;
  const bannerHeight = theme?.headerHeight;
  const isBackground = headerLayout === HEADER_LAYOUT.BACKGROUND && Boolean(headerImage);

  const [dismissed, setDismissed] = useState(() => {
    try {
      return sessionStorage.getItem(GREETING_KEY) === 'true';
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    if (dismissed) {
      return () => {};
    }

    const onScroll = () => {
      if (window.scrollY > 8) {
        setDismissed(true);
        try {
          sessionStorage.setItem(GREETING_KEY, 'true');
        } catch (e) {
          // ignore
        }
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
    };
  }, [dismissed]);

  if (isBackground) {
    return (
      <ThemeBackgroundHeader
        image={headerImage}
        fit={headerFit}
        height={bannerHeight}
        aspectRatio={theme?.headerAspectRatio}
        title={dismissed ? 'Consolidado' : 'Olá, bem vindo(a) de novo 👋'}
      />
    );
  }

  if (!dismissed) {
    return (
      <PageHeader
        title="Olá, bem vindo(a) de novo 👋"
        backgroundImage={headerImage}
        fit={headerFit}
        bannerHeight={bannerHeight}
      />
    );
  }

  if (isHorizontal && !headerImage) {
    return null;
  }

  return (
    <PageHeader
      title="Consolidado"
      backgroundImage={headerImage}
      fit={headerFit}
      bannerHeight={bannerHeight}
    />
  );
}